import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { makeStyles, Button } from "@material-ui/core";
import { shouldRenderComponent } from "../shared/util/ComponentAuth";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { convertDate } from "../shared/util/utils";
import { getFullPath } from "../config/retailerConfig";

import {
  cashoutHistory,
  getCashoutEmails,
} from "../service/myloyalty_services";

function ShopperCashoutHistory({ page, retailer, profilePage, blockConfig }) {
  const navigate = useNavigate();
  const retailerConfig = retailer;
  const [receiptHistory, setReceiptHistory] = useState([]);

  const [cashoutEmails, setCashoutEmails] = useState([]);
  const [width, setWidth] = useState(window.innerWidth);
  // filtering the compoenent config for account page
  const component =
    profilePage &&
    page.components.filter(
      (item) => item.block_type === "CashoutHistoryBlock"
    )[0];
  const isMobile = width <= 768;
  const anchorId = profilePage ? component?.anchorId : blockConfig?.anchorId;
  const headerTextColor = profilePage
    ? component?.header_text_color
    : blockConfig?.header_text_color;
  const header_text = profilePage
    ? component?.header_text
    : blockConfig?.header_text;

  function formatPrice(price) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
    }).format(price / 100);
  }

  const useStyles = makeStyles((theme) => ({
    contentPage: {
      maxWidth: "1200px",
      margin: "auto",
      // padding: "80px 0",
      [theme.breakpoints.down(1201)]: {
        padding: profilePage ? "0px 40px" : "0px 64px",
      },
      [theme.breakpoints.down(1025)]: {
        padding: profilePage ? "0px 40px" : "0px 64px",
      },
      [theme.breakpoints.down(769)]: {
        padding: profilePage ? "0px 0px" : "0px 16px",
      },
    },
    shoppingTitle: {
      fontWeight: 800,
      fontFamily: "Switzer",
      fontSize: profilePage ? "42px" : "90px",
      lineHeight: "81px",
      textAlign: profilePage ? "" : "center",
      marginBottom: "0px",
      paddingBottom: profilePage ? "30px" : "",

      [theme.breakpoints.down("sm")]: {
        fontSize: "36px",
        marginTop: "0px",
        textAlign: "center",
        letterSpacing: "-0.36px",
      },
    },
    shoppingTitleContainer: {
      marginBottom: profilePage ? "" : "64px",
      [theme.breakpoints.down("sm")]: {
        marginBottom: "0px",
      },
    },
    shoppingColTitle: {
      "&.MuiTableCell-root": {
        fontWeight: "700",
        fontFamily: "Switzer",
        fontSize: "16px",
        lineHeight: "24px",
        width: "33%",
      },
    },
    shoppingColText: {
      "&.MuiTableCell-root": {
        fontWeight: "400",
        fontFamily: "Switzer",
        fontSize: "18px",
        lineHeight: "27px",
        width: "33%",
      },
    },
    shoppingMobileTitle: {
      fontWeight: 800,
      fontFamily: "Switzer",
      fontSize: profilePage ? "30px" : "36px",
      lineHeight: "32px",
      textAlign: profilePage ? "" : "center",
      marginBottom: profilePage ? "30px" : "24px",
      marginTop: profilePage ? "0px" : "24px",
    },
    shoppingMobileTitleContainer: {
      marginBottom: "24px",
    },
    shoppingMobileColTitle: {
      "&.MuiTypography-root": {
        fontWeight: "700",
        fontFamily: "Switzer",
        fontSize: "14px",
        lineHeight: "21px",
      },
    },
    shoppingMobileColText: {
      "&.MuiTypography-root": {
        fontWeight: "400",
        fontFamily: "Switzer",
        fontSize: "14px",
        lineHeight: "21px",
      },
    },
    link: {
      "&:hover": {
        textDecoration: "none",
      },
      "&:active": {
        textDecoration: "none",
      },
      cursor: "text",
    },
    emptyMsg: {
      fontFamily: "switzer",
      fontSize: "18px",
      color: "#25272C",
      display: "flex",
      justifyContent: "center",

      [theme.breakpoints.down("sm")]: {
        marginBottom: "16px",
        fontSize: "16px",
        padding: "16px 20px",
      },
    },
    success: {
      borderRadius: "4px",
      background: "#EAF6EC",
      color: "#28A745",
      fontWeight: 700,
      fontSize: "18px",
      padding: "4px 16px",
      textTransform: "capitalize",
      [theme.breakpoints.down("sm")]: {
        fontSize: "14px",
      },
    },
    failed: {
      borderRadius: "4px",
      background: "#FCEBEC",
      color: "#DC3545",
      fontWeight: 700,
      fontSize: "18px",
      padding: "4px 16px",
      textTransform: "capitalize",
      [theme.breakpoints.down("sm")]: {
        fontSize: "14px",
      },
      viewMoreButton: {
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "18px",
        fontWeight: "700",
        lineHeight: "27px",
        boxShadow:
          "0px 2px 4px 0px rgba(107, 114, 128, 0.12), 0px 3px 5px 0px rgba(107, 114, 128, 0.15)",
        padding: "16px",
        borderRadius: "240px",
        marginTop: "32px",
        textTransform: "capitalize",
      },
    },
  }));
  const classes = useStyles();

  useEffect(() => {
    // calling api to get usernames of acc id
    getCashoutEmails(retailerConfig.retailer_dpn_instance.dpn_instance)
      .then((data) => {
        setCashoutEmails(data);
      })
      .catch((error) => {
        console.error("Error fetching shopping history:", error);
      });
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    // caaling cashout history api
    cashoutHistory(retailerConfig.retailer_dpn_instance.dpn_instance)
      .then((result) => {
        // filtering the external/paypal data only
        const filteredResult = result.filter(
          (item) => item.redemptionType === "external"
        );
        if (!profilePage) {
          // slicing for home page view more
          setReceiptHistory(filteredResult.slice(0, 3));
        } else {
          setReceiptHistory(filteredResult);
        }
      })
      .catch((error) => {
        console.error("Error fetching shopping history:", error);
      });
  }, [cashoutEmails]);

  if (!shouldRenderComponent(page.auth_visibility)) {
    return null;
  }
  return (
    <>
      {
        <div className={classes.contentPage}>
          <div
            className={
              isMobile
                ? classes.shoppingMobileTitleContainer
                : classes.shoppingTitleContainer
            }
          >
            <p
              id={anchorId}
              className={
                isMobile ? classes.shoppingMobileTitle : classes.shoppingTitle
              }
              style={{ color: headerTextColor }}
            >
              {header_text}
            </p>
          </div>

          {receiptHistory.length > 0 ? (
            <TableContainer
              component={Paper}
              elevation={0}
              sx={{
                border: "1px solid #B6B8C2",
                overflow: "hidden",
                borderRadius: "24px",
                backgroundColor: "#fff",
                padding: {
                  xs: "16px",
                  sm: "24px",
                  md: "48px",
                },
              }}
            >
              {isMobile ? (
                // Mobile View
                <Box sx={{ padding: 2 }}>
                  {receiptHistory.map((row, index) => (
                    <Box
                      key={convertDate(row.transactionDateTime)}
                      sx={{
                        padding: "8px",
                        borderBottom: "1px solid #e0e0e0",
                      }}
                    >
                      <Typography
                        className={classes.shoppingMobileColTitle}
                        variant="h6"
                        align="left"
                        gutterBottom
                      >
                        {convertDate(row.transactionDateTime)}
                      </Typography>

                      {/* Row for purchased and date */}
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          className={classes.shoppingMobileColText}
                          variant="body2"
                          align="left"
                          color="textSecondary"
                        >
                          Transaction Date
                        </Typography>
                        <Typography
                          className={classes.shoppingMobileColText}
                          variant="body1"
                          align="right"
                        >
                          {convertDate(row.transactionDateTime)}
                        </Typography>
                      </Box>

                      {/* Row for valid purchased amount and amount value */}
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          className={classes.shoppingMobileColText}
                          variant="body2"
                          align="left"
                          color="textSecondary"
                        >
                          Account Details
                        </Typography>
                        <Typography
                          className={classes.shoppingMobileColText}
                          variant="body1"
                          align="right"
                        >
                          {cashoutEmails[row.accountId]}
                        </Typography>
                      </Box>
                      {/* Row for valid  amount and amount value */}
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          className={classes.shoppingMobileColText}
                          variant="body2"
                          align="left"
                          color="textSecondary"
                        >
                          Amount
                        </Typography>
                        <Typography
                          className={classes.shoppingMobileColText}
                          variant="body1"
                          align="right"
                        >
                          {formatPrice(row.amount)}
                        </Typography>
                      </Box>
                      {/* Row for valid Status */}
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          className={classes.shoppingMobileColText}
                          variant="body2"
                          align="left"
                          color="textSecondary"
                        >
                          Status
                        </Typography>
                        <Typography
                          className={classes.shoppingMobileColText}
                          variant="body1"
                          align="right"
                        >
                          <div
                            className={`${
                              row.payoutItems[0].status == "failed"
                                ? classes.failed
                                : classes.success
                            }`}
                          >
                            {row.payoutItems[0].status}
                          </div>
                        </Typography>
                      </Box>
                    </Box>
                  ))}

                  {/* view more button */}

                  {!profilePage && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        margin: "8px",
                      }}
                    >
                      <Button
                        className={classes.viewMoreButton}
                        style={{
                          background: blockConfig?.blockstyle_set[0]
                            ?.button_background_color
                            ? blockConfig?.blockstyle_set[0]
                                ?.button_background_color
                            : "#53128C",
                          color: blockConfig?.blockstyle_set[0]
                            ?.button_text_color
                            ? blockConfig?.blockstyle_set[0]?.button_text_color
                            : "#fff",
                        }}
                        onClick={() => {
                          navigate(getFullPath("account"));
                        }}
                      >
                        View More
                      </Button>
                    </div>
                  )}
                </Box>
              ) : (
                // Desktop View
                <>
                  <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell
                          className={classes.shoppingColTitle}
                          align="left"
                        >
                          Transaction Date
                        </TableCell>
                        <TableCell
                          className={classes.shoppingColTitle}
                          align="right"
                        >
                          Account Details
                        </TableCell>
                        <TableCell
                          className={classes.shoppingColTitle}
                          align="right"
                        >
                          Amount
                        </TableCell>
                        <TableCell
                          className={classes.shoppingColTitle}
                          align="right"
                        >
                          Status
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody
                      sx={{
                        "& td, & th": { border: 0 },
                      }}
                    >
                      {receiptHistory.map((row, index) => (
                        <TableRow
                          key={row.receipt}
                          sx={{
                            backgroundColor:
                              index % 2 === 0 ? "#ffffff" : "#f5f5f5",
                          }}
                        >
                          <TableCell
                            className={classes.shoppingColText}
                            align="left"
                          >
                            {convertDate(row.transactionDateTime)}
                          </TableCell>
                          <TableCell
                            className={classes.shoppingColText}
                            align="right"
                          >
                            {cashoutEmails[row.accountId]}
                          </TableCell>
                          <TableCell
                            className={classes.shoppingColText}
                            align="right"
                          >
                            {formatPrice(row.amount)}
                          </TableCell>
                          <TableCell
                            className={classes.shoppingColText}
                            align="right"
                          >
                            <div
                              className={`${
                                row.payoutItems[0].status == "failed"
                                  ? classes.failed
                                  : classes.success
                              }`}
                            >
                              {row.payoutItems[0].status}
                            </div>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>

                  {/*  view more button  */}
                  {!profilePage && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        margin: "8px",
                      }}
                    >
                      <Button
                        className={classes.viewMoreButton}
                        style={{
                          background: blockConfig?.blockstyle_set[0]
                            ?.button_background_color
                            ? blockConfig?.blockstyle_set[0]
                                ?.button_background_color
                            : "#53128C",
                          color: blockConfig?.blockstyle_set[0]
                            ?.button_text_color
                            ? blockConfig?.blockstyle_set[0]?.button_text_color
                            : "#fff",
                        }}
                        onClick={() => {
                          navigate(getFullPath("account"));
                        }}
                      >
                        View More
                      </Button>
                    </div>
                  )}
                </>
              )}
            </TableContainer>
          ) : (
            <p className={classes.emptyMsg}>
              You have not made any cashouts yet!
            </p>
          )}
        </div>
      }
    </>
  );
}

export default ShopperCashoutHistory;
